import React, { useMemo } from 'react'
import { observer } from 'mobx-react'
import { payChannelMobx, payPlanMobx } from '@mobxStore'
import { sortBy } from '@dt/fe-utils/dist/lodash'
import BankCardOnline from './BankCardOnline/MethodItem'
import ApplePayWeb from './ApplePayWeb/MethodItem'
import PaypalMethodItem from './PayPalWeb/PayPalMethodItem'
import AlipayMethodItem from './Alipay/MethodItem'
import WechatPay from './WechatPay/MethodItem'
import MemberCardPay from './MemberCardPay'
import ExternalPayNone from './ExternalPayNone'
import GiftCardPay from './GiftCardPay'
import './index.scss'

const Pay = () => {
  const list = useMemo(() => {
    return sortBy(payChannelMobx.availableMethods, v => payChannelMobx.channelSortMap?.[v]?.sort === undefined ? 9999 : payChannelMobx.channelSortMap?.[v]?.sort)
  }, [payChannelMobx.availableMethods, payChannelMobx.channelSortMap])

  return (
    payPlanMobx.totalAmount > 0 && (
      <>
        {
          list?.map(x => {
            if (x === 'BankCardOnline') {
              const method = payPlanMobx.payMethods.find(x => x.type === 'BankCardOnline') as IBankCardOnlinePayMethod
              return <BankCardOnline key={x} method={method} selected={payPlanMobx.externalMethod?.type === x} />
            } else if (x === 'ApplePayWeb') {
              return <ApplePayWeb key={x} selected={payPlanMobx.externalMethod?.type === x} />
            } else if (x === 'PayPalWeb') {
              return <PaypalMethodItem key={x} selected={payPlanMobx.externalMethod?.type === x} />
            } else if (x === 'AlipayApp') {
              return <AlipayMethodItem key={x} selected={payPlanMobx.externalMethod?.type === x} />
            } else if (x === 'WechatPayWeb') {
              return <WechatPay key={x} selected={payPlanMobx.externalMethod?.type === x} />
            } else if (x === 'MemberCard') {
              return <MemberCardPay key={x} />
            } else if (x === 'GiftCard') {
              return <GiftCardPay key={x} />
            }
          })
        }
        <ExternalPayNone />
      </>
    )
  )
}

export default observer(Pay)
